<template>
	<div class="info-form-cls">
		<section class="context-cls" :class="{'full-height':sourceType == 'CustomerSettings'}">
			<el-form labelPosition="top" autoComplete="on" :model="customerForm" ref="customerForm" :inline="true">
				<div class="show-cls">
					<div class="cell">
						<el-form-item prop="lastName" label="客户姓：" :rules="[
							{required: $$(columnList, [0], 'columnNotNull') === 'Y', trigger: 'blur', message: '请输入'}
						]">
							<el-input v-model="customerForm.lastName" maxlength="80" show-word-limit placeholder="请输入" size="small" clearable></el-input>
						</el-form-item>
					</div>
					<div class="cell">
						<el-form-item prop="firstName" label="客户名：" :rules="[
							{required: $$(columnList, [1], 'columnNotNull') === 'Y', trigger: 'blur', message: '请输入'}
						]">
							<el-input v-model="customerForm.firstName" maxlength="80" show-word-limit placeholder="请输入" size="small" clearable></el-input>
						</el-form-item>
					</div>
					<div class="cell">
						<el-form-item prop="phoneNumber" label="电话号码：" :rules="[
							{required: $$(columnList, [2], 'columnNotNull') === 'Y', trigger: 'blur', message: '请输入'},
							{trigger: 'blur', validator: validateMobile}
						]">
							<el-input v-model="customerForm.phoneNumber" placeholder="请输入" size="small" clearable style="width: calc(100% - 40px)"></el-input>
							<i @click.stop="handlePhoneAdd" class="icon-cls el-icon-circle-plus-outline"></i>
							<!-- <svg-icon icon-class="csuPhone" /> -->
						</el-form-item>
						<el-form-item prop="phoneNumber2" label="" v-if="phoneList.includes(2)" :rules="[
							{required: false, trigger: 'blur', validator: validateMobile}
						]">
							<el-input v-model="customerForm.phoneNumber2" placeholder="请输入" size="small" clearable style="width: calc(100% - 40px)"></el-input>
							<i @click.stop="handlePhoneDelete(2)" class="icon-cls el-icon-remove-outline"></i>
							<!-- <svg-icon icon-class="csuPhone" /> -->
						</el-form-item>
						<el-form-item prop="phoneNumber3" label="" v-if="phoneList.includes(3)" :rules="[
							{required: false, trigger: 'blur', validator: validateMobile}
						]">
							<el-input v-model="customerForm.phoneNumber3" placeholder="请输入" size="small" clearable style="width: calc(100% - 40px)"></el-input>
							<i @click.stop="handlePhoneDelete(3)" class="icon-cls el-icon-remove-outline"></i>
							<!-- <svg-icon icon-class="csuPhone" /> -->
						</el-form-item>
					</div>
					<div class="cell">
						<el-form-item prop="emailAddress" label="邮箱：" :rules="[
							{required: $$(columnList, [3], 'columnNotNull') === 'Y', trigger: 'blur', message: '请输入'},
							{trigger: 'blur', validator: validateEmail}
						]">
							<el-input v-model="customerForm.emailAddress" placeholder="请输入" size="small" clearable></el-input>
						</el-form-item>
					</div>
				</div>
				<div class="hide-cls">
					<div class="cell">
						<el-form-item prop="subBrand" label="子品牌：" :rules="[
							{required: true, trigger: 'blur', message: '请选择'}
						]">
							<el-select v-model="customerForm.subBrand" placeholder="请选择" size="small" filterable clearable>
								<el-option v-for="item in subBrandList" :key="item.id" :label="item.name" :value="item.id"></el-option>
							</el-select>
						</el-form-item>
					</div>
					<div class="cell">
						<el-form-item prop="channel" label="所属渠道：" :rules="[
							{required: true, trigger: 'blur', message: '请选择'}
						]">
							<el-select v-model="customerForm.channel" placeholder="请选择" size="small" filterable clearable>
								<el-option v-for="item in channelList" :key="item.id" :label="item.name" :value="item.id"></el-option>
							</el-select>
						</el-form-item>
					</div>
					<div class="cell" :class="{'width': ['text', 'file'].includes(item.displayMode)}" v-for="(item, index) in columnList" :key="index" :style="{'display': index <= 3 ? 'none' : ''}">
						<ComponentLibrary @emitMyCascader="emitMyCascader" :itemData="item" :customerForm="customerForm" />
					</div>
				</div>
			</el-form>
		</section>
		<el-divider  v-if="sourceType !== 'CustomerSettings'"></el-divider>
		<section style="text-align: center;" v-if="sourceType !== 'CustomerSettings'">
			<el-button @click.stop="$emit('closeDialogFormVisible', false);" size="mini">取 消</el-button>
			<el-button @click.stop="handleSave" :loading="loading" size="mini" type="primary">确 定</el-button>
		</section>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import { validateMobile, validateEmail } from "utils/validator";
import ComponentLibrary from 'components/CustomerInfo/Library';
export default {
	name: "CustomerAddForm",
	props: ['subBrandList', 'channelList', 'sourceType'],
	components: {ComponentLibrary},
	computed: {
        ...mapGetters([
			'userInfo',
        ])
    },
	data() {
		return {
			loading: false,
			validateMobile: validateMobile,
			validateEmail: validateEmail,
			phoneList: [1],
			columnList: [],
			customerForm: {
				subBrand: '',
				channel: '',
				lastName: '',
				firstName: '',
				phoneNumber: '',
				phoneNumber2: '',
				phoneNumber3: '',
				emailAddress: ''
			}
		}
	},
	async created() {
		this.customerForm = await {
			subBrand: '',
			channel: '',
			lastName: '',
			firstName: '',
			phoneNumber: '',
			phoneNumber2: '',
			phoneNumber3: '',
			emailAddress: ''
		};
		if (this.$refs["customerForm"]) {
			await this.$refs["customerForm"].clearValidate();
			await this.$refs["customerForm"].resetFields();
		}
		await this.getDetailInfo();
	},
	methods: {
		getDetailInfo() {
			let self = this;
			self.$api.apiQueryTabColumn({brand: self.userInfo.brandIdentify}).then(response => {
				if(response.errcode != 0) {
					self.loading = false;
					return;
				}
				// self.columnList = response.data;
				self.columnList = [];
				for(const item of response.data) {
					const optionsJson = JSON.parse(item.optionsJson);
					if(item.displayMode === 'checkbox') {
						let columnNotNull = [];
						for(const _item of optionsJson['data']) {
							if(_item.columnNotNull === 'Y') {
								columnNotNull.push(_item.value);
							}
						}
						self.$set(self.customerForm, item.columnKey, columnNotNull);
						
					} else if(['droplist', 'radio'].includes(item.displayMode)) {
						let columnNotNull = null;
						for(const _item of optionsJson['data']) {
							if(_item.columnNotNull === 'Y') {
								columnNotNull = _item;
							}
						}
						self.$set(self.customerForm, item.columnKey, columnNotNull ? columnNotNull.value : '');
					} else {
						self.$set(self.customerForm, item.columnKey, '');
					}
					if(!['wechat'].includes(item.displayMode)) {
						self.columnList.push(item);
					}
				}
			});
		},
		handleSave() {
			this.$refs["customerForm"].validate(valid => {
                if (valid) {
					this.loading = true;
					this.customerForm['brand'] = this.userInfo.brandIdentify;
                    this.$api.apiAddCustomer(this.customerForm).then(response => {
						if(response.errcode != 0) {
							this.loading = false;
							return;
						}
						this.$notify({
							title: '保存成功',
							type: 'success'
						});
						this.loading = false;
						this.$emit('closeDialogFormVisible', true);
					});
                }
            });
			
		},
		emitMyCascader(obj) {
			this.customerForm = Object.assign(this.customerForm, obj);
		},
		handlePhoneAdd() {
			if(this.phoneList.length === 3) {
				return;
			}
			this.phoneList.push(this.phoneList.includes(2) ? 3 : 2);
		},
		handlePhoneDelete(i) {
			this.phoneList.splice(this.phoneList.indexOf(i), 1);
		}
	}
}
</script>

<style lang="scss" scoped>
.info-form-cls {
	width: 100%;

	& > .context-cls {
		width: 100%;
		padding-bottom: 20px;
		box-sizing: border-box;
		width: 100%;
		height: 450px;
		overflow-x: hidden;
		overflow-y: auto;
		&.full-height {
			height: auto;
		}

		& .cell {
			display: inline-block;
			width: 50%;
			padding: 0 10px;
			box-sizing: border-box;
			vertical-align: top;

			&.width {
				width: 100%;
			}

			::v-deep .el-form-item {
				width: 100%;
				& > .el-form-item__label {
					padding: 0;
					line-height: 30px;
					white-space: nowrap;
					overflow: hidden;
					text-overflow: ellipsis;
				}

				& .el-form-item__content {
					& .el-input, & .el-select, & .el-date-picker, & .el-input-number, & .el-cascader {
						vertical-align: top;
						display: inline-block;
						width: 100%;
					}

					& .el-input-number {
						margin-top: 2px;
					}

					& .el-upload, & .el-upload-dragger {
						width: 100%;
					}

					& .icon-cls {
						vertical-align: top;
						display: inline-block;
						font-size: 16px;
						margin: 0 12px;
						cursor: pointer;
						color: #000000;
						position: relative;
						top: 11px;
					}

					& .svg-icon {
						vertical-align: top;
						display: inline-block;
						width: 28px;
						height: 28px;
						cursor: pointer;
						position: relative;
						top: 4px;
					}

					& .el-radio-group {
						line-height: 48px;
					}
				}
			}
		}
	}
}
</style>
